export default "__VITE_ASSET__kGHmisXu__"